import React, { useState } from 'react';

const CategoryCard = ({ categoryData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Categories that should show the simplified list + detailed "pill" view
  const isHeavyCategory = ["Institutos", "Disciplinas Deportivas", "Comisiones", "Token"].includes(categoryData.category);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };

  const handleBackToList = () => {
    setSelectedItem(null);
  };

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className="group bg-white rounded-xl shadow-sm border border-slate-200 hover:shadow-md hover:border-slate-300 transition-all duration-300 cursor-pointer overflow-hidden flex flex-col h-full"
      >
        <div className="p-6 pb-2 transition-transform duration-300 group-hover:-translate-y-1">
          <h3 className="text-xl font-bold text-primary-900 mb-3 group-hover:text-primary-600 transition-colors leading-tight">
            {categoryData.category}
          </h3>
          <p className="text-sm text-slate-500 line-clamp-3 leading-relaxed">
            {categoryData.description}
          </p>
        </div>
        <div className="mt-auto bg-slate-50 p-3 text-center border-t border-slate-100 group-hover:bg-primary-50 transition-colors">
          <span className="text-xs font-bold text-primary-600 uppercase tracking-widest">
            Ver Información
          </span>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col animate-slide-up overflow-hidden border border-white/20">

            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 md:p-8 border-b border-slate-100 bg-white relative z-10">
              <div className="flex items-center gap-4">
                {selectedItem && (
                  <button
                    onClick={handleBackToList}
                    className="p-2 -ml-2 text-slate-400 hover:text-primary-600 hover:bg-primary-50 rounded-full transition-all"
                    title="Volver al listado"
                  >
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                )}
                <div>
                  <h2 className="text-2xl md:text-3xl font-black text-primary-900 leading-none">
                    {selectedItem ? selectedItem.title : categoryData.category}
                  </h2>
                  {!selectedItem && <p className="text-sm text-slate-500 mt-2 font-medium">{categoryData.description}</p>}
                </div>
              </div>
              <button
                onClick={handleCloseModal}
                className="p-2 text-slate-300 hover:text-red-500 hover:bg-red-50 rounded-full transition-all"
              >
                <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex-grow p-6 md:p-8 overflow-y-auto custom-scrollbar bg-slate-50/30">
              {selectedItem ? (
                /* DETAILED VIEW (PASTILLA INDEPENDIENTE) */
                <div className="max-w-2xl mx-auto animate-fade-in">
                  <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-slate-200">
                    <div className="flex items-center gap-3 mb-6">
                      <span className="px-3 py-1 bg-primary-100 text-primary-700 text-[10px] font-black uppercase tracking-widest rounded-full">
                        {categoryData.category}
                      </span>
                    </div>

                    <h3 className="text-3xl font-black text-primary-900 mb-6 leading-tight">
                      {selectedItem.title}
                    </h3>

                    {selectedItem.text && (
                      <div className="text-lg md:text-xl text-slate-700 leading-relaxed font-normal whitespace-pre-wrap mb-8">
                        {selectedItem.text}
                      </div>
                    )}

                    {selectedItem.actions && selectedItem.actions.length > 0 ? (
                      <div className="flex flex-col gap-4 mt-8">
                        {selectedItem.actions.map((action, idx) => (
                          <a
                            key={idx}
                            href={action.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`inline-flex items-center justify-center w-full px-8 py-4 font-bold rounded-2xl transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 ${action.type === 'whatsapp'
                              ? 'bg-[#25D366] text-white hover:bg-[#128C7E]'
                              : 'bg-primary-600 text-white hover:bg-primary-700'
                              }`}
                          >
                            {action.label}
                            <svg className="w-5 h-5 ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                          </a>
                        ))}
                      </div>
                    ) : (
                      selectedItem.url && selectedItem.url !== '#' && (
                        selectedItem.url.startsWith('mailto:') ? (
                          <div className="mt-8 p-6 bg-primary-50 rounded-2xl border-2 border-primary-200 flex flex-col items-center text-center animate-fade-in shadow-sm">
                            <span className="text-primary-700 font-extrabold text-xs uppercase tracking-widest mb-2 italic">Enviar Correo a:</span>
                            <span className="text-xl md:text-2xl font-black text-primary-900 break-all select-all hover:text-primary-600 transition-colors">
                              {selectedItem.url.replace('mailto:', '')}
                            </span>
                          </div>
                        ) : (
                          <a
                            href={selectedItem.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center w-full md:w-auto px-8 py-4 bg-primary-600 text-white font-bold rounded-2xl hover:bg-primary-700 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
                          >
                            Acceder al sitio oficial
                            <svg className="w-5 h-5 ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                          </a>
                        )
                      )
                    )}

                    <button
                      onClick={handleBackToList}
                      className="mt-6 flex items-center text-slate-400 font-bold text-sm hover:text-primary-600 transition-colors"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7 7-7" />
                      </svg>
                      Volver al listado
                    </button>
                  </div>
                </div>
              ) : (
                /* LIST VIEW */
                categoryData.links && categoryData.links.length > 0 ? (
                  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-2">
                    {categoryData.links.map((link, index) => {
                      const isExternalLink = link.url !== '#' && !isHeavyCategory;

                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (isHeavyCategory || !isExternalLink) {
                              setSelectedItem(link);
                            } else if (isExternalLink) {
                              window.open(link.url, '_blank', 'noopener,noreferrer');
                            }
                          }}
                          className="group bg-white p-6 rounded-2xl border border-slate-200 hover:border-primary-400 hover:shadow-md transition-all duration-200 cursor-pointer flex flex-col justify-between"
                        >
                          <div className="flex justify-between items-start gap-3">
                            <h4 className="font-bold text-lg text-primary-900 group-hover:text-primary-600 transition-colors leading-tight">
                              {link.title}
                            </h4>
                            <div className="p-1.5 bg-slate-50 rounded-lg group-hover:bg-primary-50 transition-colors">
                              <svg className="w-5 h-5 text-slate-400 group-hover:text-primary-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </div>
                          </div>

                          {!isHeavyCategory && link.text && (
                            <p className="mt-3 text-sm text-slate-500 line-clamp-2">
                              {link.text}
                            </p>
                          )}

                          <div className="mt-4 flex items-center text-[10px] font-black uppercase tracking-widest text-primary-500 opacity-60 group-hover:opacity-100 transition-opacity">
                            {isExternalLink ? "Abrir enlace" : "Click para más info"}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-20">
                    <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <p className="text-slate-500 font-medium">No hay información disponible.</p>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryCard;
